module.exports = __webpack_public_path__ + "img/icon_map_5_on_101.5efde2b5.png";